webpackJsonp([79611799117203,60335399758886],{

/***/ 133:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"excerpt":"Next Software is led by a team of engineers with over 20+ years experience with machine learning, deep learning, and marketing automation solutions.","id":"/opt/build/repo/content/about/about.md absPath of file >>> MarkdownRemark","frontmatter":{"contentType":"about","postimage":null,"date":null,"path":"/about","summary":null,"newsFlag":null,"title":"Our Team","button":null,"header":null,"personName":null,"personRole":null,"mission":null}}},{"node":{"excerpt":"","id":"/opt/build/repo/content/contact/mission.md absPath of file >>> MarkdownRemark","frontmatter":{"contentType":"contact","postimage":null,"date":null,"path":"/contact","summary":null,"newsFlag":null,"title":"Contact","button":null,"header":null,"personName":null,"personRole":null,"mission":"Next Software’s mission is to turbocharge growth for companies with amazing leads. By streamlining the manual, repetitive tasks traditionally associated with prospecting, marketers and sales pros have more time to spend enriching experiences with their customers."}}},{"node":{"excerpt":"","id":"/opt/build/repo/content/home-banner/2018-06-07-banner-home.md absPath of file >>> MarkdownRemark","frontmatter":{"contentType":"banner","postimage":null,"date":null,"path":"/banner-home1","summary":null,"newsFlag":null,"title":"","button":"Register","header":"Alternative header","personName":"Manish Kumar","personRole":"CTO","mission":null}}},{"node":{"excerpt":"","id":"/opt/build/repo/content/home-banner/banner.md absPath of file >>> MarkdownRemark","frontmatter":{"contentType":"banner","postimage":null,"date":null,"path":"/banner-home","summary":null,"newsFlag":null,"title":"","button":"Get started","header":"Next Software makes development easy","personName":"Deepak","personRole":"Chief Tech Officer","mission":null}}},{"node":{"excerpt":"Second Blog","id":"/opt/build/repo/content/blog/2018-03-07-second-blog/index.md absPath of file >>> MarkdownRemark","frontmatter":{"contentType":"blog","postimage":"","date":"January 18, 2018","path":"/blog/second-blog","summary":"This is the second blog","newsFlag":false,"title":"Second Blog in folder","button":null,"header":null,"personName":null,"personRole":null,"mission":null}}},{"node":{"excerpt":"First Blog","id":"/opt/build/repo/content/blog/2018-02-06-first-blog.md absPath of file >>> MarkdownRemark","frontmatter":{"contentType":"blog","postimage":"/files/images/my_pic2.jpg","date":"January 17, 2018","path":"/blog/first-blog","summary":"This is the first blog","newsFlag":false,"title":"First Blog","button":null,"header":null,"personName":null,"personRole":null,"mission":null}}}]},"site":{"siteMetadata":{"title":"Next Software"}},"allFile":{"edges":[{"node":{"name":"how-we-work","relativeDirectory":""}},{"node":{"name":"index","relativeDirectory":""}},{"node":{"name":"why-us","relativeDirectory":""}},{"node":{"name":"why-us-old","relativeDirectory":""}},{"node":{"name":"index","relativeDirectory":"capabilities"}},{"node":{"name":"progressive-web-apps","relativeDirectory":"capabilities"}},{"node":{"name":"serverless","relativeDirectory":"capabilities"}},{"node":{"name":"angular-js","relativeDirectory":"technologies"}},{"node":{"name":"django","relativeDirectory":"technologies"}},{"node":{"name":"index","relativeDirectory":"technologies"}},{"node":{"name":"node-js","relativeDirectory":"technologies"}},{"node":{"name":"react-js","relativeDirectory":"technologies"}}]}},"layoutContext":{}}

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(262);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(133);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'footer footer-dark' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns footer-columns is-flex-mobile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-half-mobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'footer-column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-header' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Company'
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'link-list' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/' },
	                  ' Home '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/why-us' },
	                  ' Why Us '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/how-we-work' },
	                  ' How We Work '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#contact-form' },
	                  'Contact'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-half-mobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'footer-column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-header' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Technology'
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'link-list' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/technologies/angular-js' },
	                  ' AngularJS '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/technologies/react-js' },
	                  ' ReactJS '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/technologies/node-js' },
	                  ' NodeJS '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/technologies/django' },
	                  ' Django '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-half-mobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'footer-column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'footer-header' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                ' Services '
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'link-list' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/capabilities/progressive-web-apps' },
	                  ' Progressive Web Apps '
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/capabilities/serverless' },
	                  ' Serverless '
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-half-mobile' },
	          _react2.default.createElement('div', { className: 'footer-column' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-half-mobile' },
	          _react2.default.createElement(
	            'div',
	            { className: 'footer-column' },
	            _react2.default.createElement(
	              'p',
	              { className: 'pt-10 pb-10' },
	              _react2.default.createElement(
	                'a',
	                { href: '#contact-form', className: 'button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2' },
	                'Let\'s build together'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'copyright' },
	              _react2.default.createElement(
	                'span',
	                { className: 'moto light-text' },
	                'Designed and Developed with',
	                _react2.default.createElement('img', { src: '/files/images/logos/footer/nodejs-logo.png', alt: '' }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  ' ',
	                  '    ',
	                  ' ',
	                  '  '
	                ),
	                _react2.default.createElement('img', { src: '/files/images/logos/footer/reactjs-logo.png', alt: '' })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(8);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(478);
	
	__webpack_require__(477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ContactSection from 'components/Contact';
	
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  App.prototype.render = function render() {
	    // eslint-disable-next-line
	    var _props = this.props,
	        data = _props.data,
	        location = _props.location;
	
	    console.log(this.props);
	    var rootClasses = '';
	    switch (location.pathname) {
	      case '/':
	        rootClasses = 'dark-header';
	        break;
	      case '/why-us':
	        rootClasses = 'transparent-header why-us-page';
	        break;
	      case '/capabilities/progressive-web-apps':
	        rootClasses = 'transparent-header white-bg-right pwa-page';
	        break;
	      default:
	        rootClasses = 'transparent-header';
	        break;
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'root-cont ' + rootClasses },
	      _react2.default.createElement(
	        'main',
	        { className: 'main-cont' },
	        this.props.children()
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'backtotop' },
	        _react2.default.createElement('a', { href: '#' })
	      ),
	      _react2.default.createElement(_Footer2.default, { location: location })
	    );
	  };
	
	  return App;
	}(_react2.default.Component);
	
	exports.default = App;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-616fbe2d7fd9ab7abb62.js